import React, { useEffect } from "react";
import LandingPage from "../../UI/pages/LandingPage/LandlingPage";
import About from "../../UI/pages/About/About";
import Contact from "../../UI/pages/Contact/Contact";
import { Routes, Route, Navigate } from "react-router-dom";
import Faq from "../../UI/pages/Faq/Faq";
import Features from "../../UI/pages/Features/Features";

import { useLocation } from "react-router-dom";
// export const ScrollToTop = () => {
//   const { pathname } = useLocation();
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return null;
// };
function App() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div>
      {/* <ScrollToTop /> */}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/faqs" element={<Faq />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/features" element={<Features />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default App;
